module.exports = __webpack_public_path__ + "img/startwaves_logo_2024_svg_v4_256.svg";